import { useEffect, useState } from 'react';

/**
 * Returns `previewSrc` until `fullSrc` has finished loading, then `fullSrc`.
 * If the full image fails to load, the preview stays.
 */
export function useProgressiveImageSrc(
  previewSrc: string | null,
  fullSrc: string | null
): string | null {
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!fullSrc || fullSrc === previewSrc || fullSrc === loadedSrc) {
      return;
    }

    const img = new Image();
    img.onload = () => setLoadedSrc(fullSrc);
    img.src = fullSrc;

    return () => {
      img.onload = null;
    };
  }, [previewSrc, fullSrc, loadedSrc]);

  return fullSrc && fullSrc === loadedSrc ? fullSrc : (previewSrc ?? fullSrc);
}
